import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.11031 12.3887C6.89552 12.1739 6.89552 11.8257 7.11031 11.6109L9.7214 8.9998L7.11031 6.38871C6.89552 6.17392 6.89552 5.82568 7.11031 5.6109C7.3251 5.39611 7.67334 5.39611 7.88813 5.6109L10.8881 8.6109C11.1029 8.82568 11.1029 9.17392 10.8881 9.38871L7.88813 12.3887C7.67334 12.6035 7.3251 12.6035 7.11031 12.3887Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }